import api from '../services/api';

/**
 * Detects the user's location based on their IP address.
 * @returns {Promise<Object>} Object containing country code (alpha-2) and other details.
 */
export const detectUserLocation = async () => {
  try {
    const response = await api.get('/website/location');
    return response.data;
  } catch (error) {
    return { countryCode: 'GB', countryName: 'United Kingdom' }; // Default to UK
  }
};

export const COUNTRY_PREFIX_MAP = {
  'AF': '+93', 'Afghanistan': '+93',
  'AL': '+355', 'Albania': '+355',
  'DZ': '+213', 'Algeria': '+213',
  'AD': '+376', 'Andorra': '+376',
  'AO': '+244', 'Angola': '+244',
  'AG': '+1-268', 'Antigua and Barbuda': '+1-268',
  'AR': '+54', 'Argentina': '+54',
  'AM': '+374', 'Armenia': '+374',
  'AU': '+61', 'Australia': '+61',
  'AT': '+43', 'Austria': '+43',
  'AZ': '+994', 'Azerbaijan': '+994',
  'BS': '+1-242', 'Bahamas': '+1-242',
  'BH': '+973', 'Bahrain': '+973',
  'BD': '+880', 'Bangladesh': '+880',
  'BB': '+1-246', 'Barbados': '+1-246',
  'BY': '+375', 'Belarus': '+375',
  'BE': '+32', 'Belgium': '+32',
  'BZ': '+501', 'Belize': '+501',
  'BJ': '+229', 'Benin': '+229',
  'BT': '+975', 'Bhutan': '+975',
  'BO': '+591', 'Bolivia': '+591',
  'BA': '+387', 'Bosnia and Herzegovina': '+387',
  'BW': '+267', 'Botswana': '+267',
  'BR': '+55', 'Brazil': '+55',
  'BN': '+673', 'Brunei': '+673',
  'BG': '+359', 'Bulgaria': '+359',
  'BF': '+226', 'Burkina Faso': '+226',
  'BI': '+257', 'Burundi': '+257',
  'KH': '+855', 'Cambodia': '+855',
  'CM': '+237', 'Cameroon': '+237',
  'CA': '+1', 'Canada': '+1',
  'CV': '+238', 'Cape Verde': '+238',
  'CF': '+236', 'Central African Republic': '+236',
  'TD': '+235', 'Chad': '+235',
  'CL': '+56', 'Chile': '+56',
  'CN': '+86', 'China': '+86',
  'CO': '+57', 'Colombia': '+57',
  'KM': '+269', 'Comoros': '+269',
  'CG': '+242', 'Congo': '+242',
  'CD': '+243', 'Democratic Republic of the Congo': '+243',
  'CR': '+506', 'Costa Rica': '+506',
  'CI': '+225', 'Ivory Coast': '+225',
  'HR': '+385', 'Croatia': '+385',
  'CU': '+53', 'Cuba': '+53',
  'CY': '+357', 'Cyprus': '+357',
  'CZ': '+420', 'Czech Republic': '+420',
  'DK': '+45', 'Denmark': '+45',
  'DJ': '+253', 'Djibouti': '+253',
  'DM': '+1-767', 'Dominica': '+1-767',
  'DO': '+1-809', 'Dominican Republic': '+1-809',
  'EC': '+593', 'Ecuador': '+593',
  'EG': '+20', 'Egypt': '+20',
  'SV': '+503', 'El Salvador': '+503',
  'GQ': '+240', 'Equatorial Guinea': '+240',
  'ER': '+291', 'Eritrea': '+291',
  'EE': '+372', 'Estonia': '+372',
  'ET': '+251', 'Ethiopia': '+251',
  'FJ': '+679', 'Fiji': '+679',
  'FI': '+358', 'Finland': '+358',
  'FR': '+33', 'France': '+33',
  'GA': '+241', 'Gabon': '+241',
  'GM': '+220', 'Gambia': '+220',
  'GE': '+995', 'Georgia': '+995',
  'DE': '+49', 'Germany': '+49',
  'GH': '+233', 'Ghana': '+233',
  'GR': '+30', 'Greece': '+30',
  'GD': '+1-473', 'Grenada': '+1-473',
  'GT': '+502', 'Guatemala': '+502',
  'GN': '+224', 'Guinea': '+224',
  'GW': '+245', 'Guinea-Bissau': '+245',
  'GY': '+592', 'Guyana': '+592',
  'HT': '+509', 'Haiti': '+509',
  'HN': '+504', 'Honduras': '+504',
  'HU': '+36', 'Hungary': '+36',
  'IS': '+354', 'Iceland': '+354',
  'IN': '+91', 'India': '+91',
  'ID': '+62', 'Indonesia': '+62',
  'IR': '+98', 'Iran': '+98',
  'IQ': '+964', 'Iraq': '+964',
  'IE': '+353', 'Ireland': '+353',
  'IL': '+972', 'Israel': '+972',
  'IT': '+39', 'Italy': '+39',
  'JM': '+1-876', 'Jamaica': '+1-876',
  'JP': '+81', 'Japan': '+81',
  'JO': '+962', 'Jordan': '+962',
  'KZ': '+7', 'Kazakhstan': '+7',
  'KE': '+254', 'Kenya': '+254',
  'KI': '+686', 'Kiribati': '+686',
  'KP': '+850', 'North Korea': '+850',
  'KR': '+82', 'South Korea': '+82',
  'KW': '+965', 'Kuwait': '+965',
  'KG': '+996', 'Kyrgyzstan': '+996',
  'LA': '+856', 'Laos': '+856',
  'LV': '+371', 'Latvia': '+371',
  'LB': '+961', 'Lebanon': '+961',
  'LS': '+266', 'Lesotho': '+266',
  'LR': '+231', 'Liberia': '+231',
  'LY': '+218', 'Libya': '+218',
  'LI': '+423', 'Liechtenstein': '+423',
  'LT': '+370', 'Lithuania': '+370',
  'LU': '+352', 'Luxembourg': '+352',
  'MK': '+389', 'Macedonia': '+389',
  'MG': '+261', 'Madagascar': '+261',
  'MW': '+265', 'Malawi': '+265',
  'MY': '+60', 'Malaysia': '+60',
  'MV': '+960', 'Maldives': '+960',
  'ML': '+223', 'Mali': '+223',
  'MT': '+356', 'Malta': '+356',
  'MH': '+692', 'Marshall Islands': '+692',
  'MR': '+222', 'Mauritania': '+222',
  'MU': '+230', 'Mauritius': '+230',
  'MX': '+52', 'Mexico': '+52',
  'FM': '+691', 'Micronesia': '+691',
  'MD': '+373', 'Moldova': '+373',
  'MC': '+377', 'Monaco': '+377',
  'MN': '+976', 'Mongolia': '+976',
  'ME': '+382', 'Montenegro': '+382',
  'MA': '+212', 'Morocco': '+212',
  'MZ': '+258', 'Mozambique': '+258',
  'MM': '+95', 'Myanmar': '+95',
  'NA': '+264', 'Namibia': '+264',
  'NR': '+674', 'Nauru': '+674',
  'NP': '+977', 'Nepal': '+977',
  'NL': '+31', 'Netherlands': '+31',
  'NZ': '+64', 'New Zealand': '+64',
  'NI': '+505', 'Nicaragua': '+505',
  'NE': '+227', 'Niger': '+227',
  'NG': '+234', 'Nigeria': '+234',
  'NO': '+47', 'Norway': '+47',
  'OM': '+968', 'Oman': '+968',
  'PK': '+92', 'Pakistan': '+92',
  'PW': '+680', 'Palau': '+680',
  'PA': '+507', 'Panama': '+507',
  'PG': '+675', 'Papua New Guinea': '+675',
  'PY': '+595', 'Paraguay': '+595',
  'PE': '+51', 'Peru': '+51',
  'PH': '+63', 'Philippines': '+63',
  'PL': '+48', 'Poland': '+48',
  'PT': '+351', 'Portugal': '+351',
  'QA': '+974', 'Qatar': '+974',
  'RO': '+40', 'Romania': '+40',
  'RU': '+7', 'Russia': '+7',
  'RW': '+250', 'Rwanda': '+250',
  'KN': '+1-869', 'Saint Kitts and Nevis': '+1-869',
  'LC': '+1-758', 'Saint Lucia': '+1-758',
  'VC': '+1-784', 'Saint Vincent and the Grenadines': '+1-784',
  'WS': '+685', 'Samoa': '+685',
  'SM': '+378', 'San Marino': '+378',
  'ST': '+239', 'Sao Tome and Principe': '+239',
  'SA': '+966', 'Saudi Arabia': '+966',
  'SN': '+221', 'Senegal': '+221',
  'RS': '+381', 'Serbia': '+381',
  'SC': '+248', 'Seychelles': '+248',
  'SL': '+232', 'Sierra Leone': '+232',
  'SG': '+65', 'Singapore': '+65',
  'SK': '+421', 'Slovakia': '+421',
  'SI': '+386', 'Slovenia': '+386',
  'SB': '+677', 'Solomon Islands': '+677',
  'SO': '+252', 'Somalia': '+252',
  'ZA': '+27', 'South Africa': '+27',
  'ES': '+34', 'Spain': '+34',
  'LK': '+94', 'Sri Lanka': '+94',
  'SD': '+20', 'Sudan': '+20',
  'SR': '+597', 'Suriname': '+597',
  'SZ': '+268', 'Swaziland': '+268',
  'SE': '+46', 'Sweden': '+46',
  'CH': '+41', 'Switzerland': '+41',
  'SY': '+963', 'Syria': '+963',
  'TW': '+886', 'Taiwan': '+886',
  'TJ': '+992', 'Tajikistan': '+992',
  'TZ': '+255', 'Tanzania': '+255',
  'TH': '+66', 'Thailand': '+66',
  'TG': '+228', 'Togo': '+228',
  'TO': '+676', 'Tonga': '+676',
  'TT': '+1-868', 'Trinidad and Tobago': '+1-868',
  'TN': '+216', 'Tunisia': '+216',
  'TR': '+90', 'Turkey': '+90',
  'TM': '+993', 'Turkmenistan': '+993',
  'TV': '+688', 'Tuvalu': '+688',
  'UG': '+256', 'Uganda': '+256',
  'UA': '+380', 'Ukraine': '+380',
  'AE': '+971', 'United Arab Emirates': '+971',
  'GB': '+44', 'United Kingdom': '+44',
  'US': '+1', 'United States': '+1',
  'UY': '+598', 'Uruguay': '+598',
  'UZ': '+998', 'Uzbekistan': '+998',
  'VU': '+678', 'Vanuatu': '+678',
  'VE': '+58', 'Venezuela': '+58',
  'VN': '+84', 'Vietnam': '+84',
  'YE': '+967', 'Yemen': '+967',
  'ZM': '+260', 'Zambia': '+260',
  'ZW': '+263', 'Zimbabwe': '+263',
};

/**
 * Maps alpha-2 country code to international phone prefix.
 * @param {string} countryCode Alpha-2 country code (e.g., 'GB')
 * @returns {string} Phone prefix (e.g., '+44')
 */
export const getPhonePrefix = (countryCode) => {
  return COUNTRY_PREFIX_MAP[countryCode] || COUNTRY_PREFIX_MAP[countryCode?.trim()] || '+44'; // Default to UK
};

/**
 * Robustly parses a phone number string into country code and local number.
 * Handles strings with or without space separators (e.g. "+92 3001234567" or "+923001234567")
 * @param {string} phone The phone number string from database
 * @param {string} isoCountryCode Optional ISO country code (e.g. 'PK') to help with disambiguation
 * @param {string} defaultPrefix Default prefix if parsing fails (e.g. '+44')
 * @returns {Object} { countryCode, phoneNumber }
 */
export const parsePhoneString = (phone, isoCountryCode = null, defaultPrefix = '+44') => {
  if (!phone) return { countryCode: defaultPrefix, phoneNumber: '' };

  // Case 1: Already has a space separator
  if (phone.includes(' ')) {
    const parts = phone.split(' ');
    return {
      countryCode: parts[0] || defaultPrefix,
      phoneNumber: parts.slice(1).join(' ')
    };
  }

  // Case 2: No space, try to use ISO countryCode if provided to detect prefix
  if (isoCountryCode) {
    const prefix = getPhonePrefix(isoCountryCode);
    if (prefix && phone.startsWith(prefix)) {
      return {
        countryCode: prefix,
        phoneNumber: phone.substring(prefix.length)
      };
    }
  }

  // Case 3: No space, no ISO match, try to find matching prefix by iteration
  if (phone.startsWith('+')) {
    // Sort prefixes by length descending to match longest possible prefix first (e.g. +1-268 before +1)
    const prefixes = Object.values(COUNTRY_PREFIX_MAP)
      .filter((v, i, a) => a.indexOf(v) === i) // unique
      .sort((a, b) => b.length - a.length);

    for (const prefix of prefixes) {
      if (phone.startsWith(prefix)) {
        return {
          countryCode: prefix,
          phoneNumber: phone.substring(prefix.length)
        };
      }
    }
  }

  return {
    countryCode: defaultPrefix,
    phoneNumber: phone
  };
};
